import { medicineLogActions } from "./action";
const initialState = {
  pickerLog: [],
  checkerLog: [],
};

export const MedicineLogReducer = (state = initialState, action) => {
  switch (action.type) {
    case medicineLogActions.ADD_TO_PICKER_LOG:
      return {
        ...state,
        pickerLog: action.payload,
      };
    case medicineLogActions.ADD_TO_CHECKER_LOG:
      return {
        ...state,
        checkerLog: action.payload,
      };
    default:
      return state;
  }
};
